<div class="container-fluid wrap">
  <div class="d-flex flex-lg-row flex-column justify-content-center">
    <div *ngIf="prop?.details?.referent?.uid" class="flex-grow-1">
      <h2 class="text-center">Votre conseiller</h2>
      <app-referent [prop]="prop" type="referent"></app-referent>
    </div>
    <div *ngIf="prop?.details?.notary?.uid" class="flex-grow-1">
      <h2 class="text-center">Votre notaire</h2>
      <app-referent [prop]="prop" type="notary"></app-referent>
    </div>
  </div>
  <div class="mt-3" *ngIf="dataSource?.data.length>0">
    <h2 class="text-center">Services partenaires</h2>

    <div *ngIf="canManageServices" class="d-flex flex-row-reverse">
      <button class="mr-2 white" mat-mini-fab appTooltip="Gérer les services" (click)="manageServices()">
        <mat-icon color="primary">settings</mat-icon>
      </button>
    </div>
    <div class="w-100" *ngIf="dataSource && dataSource.data.length > 0; else noService">
      <!-- filter -->
      <!--<div class="d-flex flex-column flex-sm-row">
        <mat-form-field>
          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre" />
        </mat-form-field>
      </div>-->
      <!-- TABLE -->
      <div [class]="tableClass">
        <table mat-table [dataSource]="dataSource" matSort>
          <!-- logo -->
          <ng-container matColumnDef="logo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let row">
              <app-img-display [uid]="row?.service.uid" [type]="'companyLogo'" [imageTs]="row?.service.companyLogoTs"
                [showNoImage]="false"></app-img-display>
            </td>
          </ng-container>
          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
            <td mat-cell *matCellDef="let row" class="main"> {{ row.companyName }}</td>
          </ng-container>
          <ng-container matColumnDef="companySummary">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Resume</th>
            <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.companySummary }}</td>
          </ng-container>
          <ng-container matColumnDef="companyCity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
            <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.companyCity }}</td>
          </ng-container>
          <ng-container matColumnDef="companyServices">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Services</th>
            <td mat-cell *matCellDef="let row">{{ row.companyServices | commaStringArray }}</td>
          </ng-container>
          <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
            <td mat-cell *matCellDef="let row">
              <button mat-flat-button color="primary"
                (click)="doContact(row.companyName, row.companyId)">Contacter</button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    <ng-template #noService>
      <span class="no-content">Aucun service n'est renseigné</span>
    </ng-template>
  </div>

  <div class="mt-3">
    <h2 class="text-center">Vos services</h2>
    <app-property-custom-services></app-property-custom-services>
  </div>
</div>